import React from 'react'
import { ConfigProvider, message, notification, theme } from 'antd'

import { figmaTheme } from '../../../_styles/figma-theme'

import antdStyles from '@/pages/tad.ai/_styles/antd.module.scss'
import { variableOpenSans } from '@/styles/next-font-variables'
import { AntdContextProvider } from '@/contexts/AntdContext'


import { cls } from 'tagged-classnames-free';
export interface IAntdLayoutProps {
  children: React.ReactNode
}

const AntdLayout: React.FC<IAntdLayoutProps> = (props) => {
  const { children } = props
  const [messageApi, messageContextHolder] = message.useMessage()
  const [notificationApi, notificationContextHolder] =
    notification.useNotification()

  return (
    <ConfigProvider
      prefixCls='coco'
      iconPrefixCls='coco-icon'
      button={{
        className: cls`${antdStyles.primaryButton}`,
      }}
      theme={{
        algorithm: [theme.darkAlgorithm],
        token: {
          fontFamily: `var(${variableOpenSans})`,
          colorPrimary: figmaTheme.primary.dark,
          colorTextLightSolid: figmaTheme.text.dark,
          colorBgContainer: figmaTheme.bgBase.dark,
          colorBgElevated: figmaTheme.bgContainer.dark,
        },
        components: {
          Divider: {
            colorText: figmaTheme.textQuaternary.dark,
            textPaddingInline: '0.75rem',
            verticalMarginInline: '6px',
          },
          Input: {
            hoverBorderColor: figmaTheme.borderHover.dark,
            activeBorderColor: figmaTheme.borderHover.dark,
          },
          Checkbox: {
            colorWhite: figmaTheme.text.dark,
          },
          Statistic: {
            colorText: figmaTheme.text.dark,
          },
          Tooltip: {
            fontSize: 14,
            colorTextLightSolid: figmaTheme.textTertiary.dark,
            colorBgSpotlight: figmaTheme.bgContainer.dark,
          },
          Button: {
            defaultShadow: '',
            primaryShadow: '',
            dangerShadow: '',
          },
          Select: {
            optionSelectedBg: figmaTheme.bgHover.dark,
            optionSelectedColor: figmaTheme.primary.dark,
          },
          Segmented: {
            itemSelectedBg: figmaTheme.bgHover.dark,
            trackBg: figmaTheme.bgContainer.dark,
            fontSize: 14,
          },
          Slider: {
            railBg: '#323247',
            trackBg: figmaTheme.primary.dark,
            trackHoverBg: figmaTheme.primary.dark,
          },
          Popover: {
            colorBgElevated: figmaTheme.bgHover.dark,
          },
        },
      }}
    >
      <AntdContextProvider message={messageApi} notification={notificationApi}>
        {messageContextHolder}
        {notificationContextHolder}
        {children}
      </AntdContextProvider>
    </ConfigProvider>
  )
}

export default AntdLayout
